import { CldrIntlService } from "@progress/kendo-angular-intl";
import { Injectable } from '@angular/core';

@Injectable()
export class CalendarIntlService extends CldrIntlService {
  public override firstDay(): number {
    return 1;
  }
}
